/**
 * External dependencies.
 */
import { assign, has, isEmpty } from 'lodash';

/**
 * Internal dependencies.
 */
import { getBackgroundStyle, getTextStyle, updateBlock, addStyleTag } from '../../extensions/custom-styles';

function styling( props, selector = false, attributes = false ) {
	const { blockAdvanceOptions, gap } = attributes ? attributes : props.attributes;
	let css = '';
	selector = selector ? selector : `.gutenify-section-${ props.clientId }`;

	css += getBackgroundStyle( blockAdvanceOptions, selector );
	css += getTextStyle( blockAdvanceOptions, selector );

	css += `${ selector }:hover {
		${ has( blockAdvanceOptions, 'hoverTextColor' ) && ! isEmpty( blockAdvanceOptions.hoverTextColor ) ? `color: ${ blockAdvanceOptions.hoverTextColor };` : '' }
		${ has( blockAdvanceOptions, 'hoverBackgroundColor' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundColor ) ? `background-color: ${ blockAdvanceOptions.hoverBackgroundColor };` : '' }
		${ has( blockAdvanceOptions, 'hoverBackgroundGradient' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundGradient ) ? `background: ${ blockAdvanceOptions.hoverBackgroundGradient };` : '' }
		${ has( blockAdvanceOptions, 'hoverBorderColor' ) && ! isEmpty( blockAdvanceOptions.hoverBorderColor ) ? `border-color: ${ blockAdvanceOptions.hoverBorderColor };` : '' }
	}`;

	css += `${ selector } {
		${ has( blockAdvanceOptions, 'borderColor' ) && ! isEmpty( blockAdvanceOptions.borderColor ) ? `border-color: ${ blockAdvanceOptions.borderColor };` : '' }
		${ blockAdvanceOptions.borderWidth ? `border-width: ${ blockAdvanceOptions.borderWidth }px;` : '' }
		${ blockAdvanceOptions.borderWidth ? `border-style: solid;` : '' }
		${ blockAdvanceOptions.borderRadius ? `border-radius: ${ blockAdvanceOptions.borderRadius };` : '' }
	}`;

	css += `${ selector } .gutenify-block-content-toggle-item-wrapper {
		${ gap ? `margin-bottom: ${ gap };` : '' }
	}`;

	return css;
}

const updateBlockStyle = ( data, props ) => {
	const attrs = assign( props.attributes, data );
	const css = styling( props, false, attrs );

	updateBlock( data, css, props );

	// Admin.
	const adminCss = styling( props, `#block-${ props.clientId }  > *` );
	addStyleTag( props, adminCss, `gutenify-block-${ props.clientId }-main`, true );
};

export { updateBlockStyle };
export default styling;

